import { Theme, ThemeProvider } from "@mui/material";
import { confirmable, ConfirmDialog, createConfirmation } from "react-confirm";

import { DeleteConfirmation } from "@/Components/v2/molecule/ConfirmationDialog";

interface DeleteBusinessUnitConfirmationProps {
  theme: Theme;
}

const DeleteBusinessUnitDialog: ConfirmDialog<DeleteBusinessUnitConfirmationProps, boolean> = ({
  show,
  proceed,
  theme,
}) => (
  <ThemeProvider theme={theme}>
    <DeleteConfirmation
      open={show}
      title={`Delete Business Unit`}
      subtitle={`Are you sure you want to delete this business unit? This action cannot be undone.`}
      deleteButtonText="Delete"
      cancelButtonText="Cancel"
      onDelete={() => proceed(true)}
      onCancel={() => proceed(false)}
    />
  </ThemeProvider>
);

const ConfirmableDialog = confirmable(DeleteBusinessUnitDialog);

export const confirmDeleteBusinessUnit = createConfirmation(ConfirmableDialog);
